import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import Assignment from '@mui/icons-material/Assignment';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { copyToClipboard } from 'utils/functions';
import { LogId, LogPropertyContainer } from 'features/logs/LogStyles';

const LogComponent = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card disablePadding>
      <Grid container alignItems={'center'} pt={2} pb={1} px={3} id={`logItem_${data.id}`} spacing={1}>
        <LogPropertyContainer item xs={4} lg={2}>
          <strong>{t('Logs.ErrorId')}:</strong>
          <LogId to={`/logs/${data.id}`}>{data.id}</LogId>
        </LogPropertyContainer>

        <LogPropertyContainer item xs={8} lg={4}>
          <span title={data.correlationId}>
            <strong>{t('Logs.CorrelationId')}:</strong>
            {data.correlationId}
          </span>
        </LogPropertyContainer>

        <LogPropertyContainer item xs={11} lg={5}>
          <span title={data.message}>
            <strong>{t('Logs.Message')}:</strong>
            {data.message}
          </span>
        </LogPropertyContainer>

        <Grid item container xs={1} justifyContent='end'>
          <IconButton
            id={`Logs_CopyBtn_${data.id}`}
            size='small'
            variant='text'
            color='primary'
            tooltip={t('General.CopyToClipboard')}
            onClick={copyToClipboard(data.message)}
          >
            <Assignment fontSize={'inherit'} />
          </IconButton>
        </Grid>
      </Grid>
    </Card>
  );
};

LogComponent.propTypes = {
  data: PropTypes.object.isRequired
};

export default LogComponent;
